// extracted by mini-css-extract-plugin
export default {"associationCards":"AssociationCardSection_associationCards__MPzgm"};